import { render, staticRenderFns } from "./institution-top10-chart.vue?vue&type=template&id=9e84968c&scoped=true&lang=pug&"
import script from "./institution-top10-chart.vue?vue&type=script&lang=ts&"
export * from "./institution-top10-chart.vue?vue&type=script&lang=ts&"
import style0 from "./institution-top10-chart.vue?vue&type=style&index=0&id=9e84968c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e84968c",
  null
  
)

export default component.exports